export const devinoFr = {
	devino: {
		ariaLabel: {
			backspace: 'Retour arrière',
			cell: 'Lettre {{position}}, {{letter}}, {{state}}',
			close: 'Fermer',
			grid: 'Grille de devinette',
			keyboard: 'Clavier virtuel',
			page: 'Jeu de mots Devino',
		},
		ariaLive: {
			absent: 'absent',
			correct: 'correct',
			guessRow: 'Ligne {{row}} : {{result}}',
			loss: 'Partie terminée. Le mot était {{word}}.',
			misplaced: 'mal placé',
			win: 'Félicitations ! Mot trouvé en {{count}} essais.',
		},
		customWord: {
			buttonLabel: 'Créez le vôtre',
			copied: 'Copié !',
			copyLink: 'Copier le lien',
			generateLink: 'Générer le lien',
			inputLabel: 'Entrez un mot',
			inputPlaceholder: 'Tapez un mot...',
			invalidLength: 'Le mot doit contenir 5, 6, 7 ou 8 lettres',
			invalidWord: 'Le mot ne doit contenir que des lettres',
			modalTitle: 'Créez votre Devino',
			play: 'Jouer',
		},
		error: {
			wrongLength: 'Le mot doit faire {{count}} lettres',
		},
		gameOver: {
			lossTitle: 'Pas de chance !',
			lossWord: 'Le mot était :',
			playAgain: 'Rejouer',
			winSubtitle: 'Mot trouvé en {{count}}/6',
			winTitle: 'Félicitations !',
		},
		header: {
			backLink: 'Portfolio',
			help: 'Comment jouer',
			settings: 'Paramètres',
			title: 'DEVINO',
		},
		howToPlay: {
			absentDesc: '<strong>{{letters}}</strong> ne sont pas dans le mot.',
			correctDesc:
				'<strong>{{letter}}</strong> est dans le mot et à la bonne position.',
			examples: 'Exemples',
			gotIt: 'Compris !',
			intro1: 'Devinez le mot caché en 6 essais.',
			intro3:
				'Après chaque essai, la couleur des cases changera pour indiquer la proximité de votre réponse.',
			misplacedDesc:
				'<strong>{{letter}}</strong> est dans le mot mais mal placé.',
			rule3: 'Vous pouvez changer la longueur et la langue dans Paramètres',
			rules: 'Règles',
			title: 'Comment jouer',
		},
		input: {
			hintLost: 'Pas de chance !',
			hintPlaying: 'Tapez votre mot...',
			hintWon: 'Vous avez trouvé le mot !',
		},
		keyboard: {
			enter: 'ENTRER',
		},
		settings: {
			keyboardLayout: 'Disposition du clavier',
			language: 'Langue',
			resetWarning: 'La partie en cours sera réinitialisée',
			title: 'Paramètres',
			wordLength: 'Longueur du mot',
		},
	},
}
